export default class CharacterSimple extends Phaser.Group {
  constructor(game, x, y, characterId, direction) {
    super(game);

    //
    this.x = x;
    this.y = y;
    this.character = this.game.make.spine(0, 0, characterId, true);
    this.character.anchor.set(0.5, 1);
    this.playAnim('idle');
    this.addChild(this.character);

    // scale
    let dir = 1;
    if (direction === 'right') {
      dir = -1;
    }
    this.dir = dir;
    this.sc = 0.4;
    this.rb = this.character.skeleton.getRootBone();
    this.rb.scaleX = this.sc * dir;
    this.rb.scaleY = this.sc;

    this.character.setSkinByName('base');

    this.updateTransform();
    this.update();
  }

  setScale(sc) {
    this.sc = sc;
    this.rb.scaleX = this.sc * this.dir;
    this.rb.scaleY = this.sc;

    this.updateTransform();
    this.update();
  }

  runTo(x, time) {
    this.playAnim('walk');
    const dir = x > this.x ? 1 : -1;
    this.setDirection(-dir);

    this.game.add.tween(this).to({ x: x }, time * 1000, null, true);
  }

  playAnim(anim, loop = true) {
    if (this.currentAnim !== anim) {
      this.currentAnim = anim;
      this.character.setAnimationByName(0, anim, loop);
    }
  }

  setDirection(dir) {
    this.character.skeleton.getRootBone().scaleX = this.sc * dir;
    this.update();
    this.updateTransform();
  }

  destroy() {
    this.character.destroy();
    this.character = null;
    super.destroy();
  }
}
